module.exports = __webpack_public_path__ + "img/2_Post.6a027bf9.jpg";